(function () {
  'use strict';

  var FRONTROW_WAIT_INTERVAL = 100;
  var FRONTROW_WAIT_TIMEOUT = 3000;

  function setLoading(button, loading) {
    if (loading) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.setAttribute('data-adv2-frontrow-label', button.getAttribute('aria-label') || '');
      button.setAttribute('aria-label', 'Loading FrontrowMD recommendations');
      return;
    }

    var label = button.getAttribute('data-adv2-frontrow-label');
    if (label) button.setAttribute('aria-label', label);
    button.removeAttribute('data-adv2-frontrow-label');
    button.removeAttribute('aria-busy');
    button.disabled = false;
  }

  function openOfficialFrontrow() {
    if (typeof window.openFrModal !== 'function') return false;

    try {
      window.openFrModal('quant', 'adv2_final_cta', '11');
      return true;
    } catch (error) {
      return false;
    }
  }

  function waitForOfficialFrontrow(button) {
    var startedAt = Date.now();
    setLoading(button, true);

    function attemptOpen() {
      if (openOfficialFrontrow()) {
        setLoading(button, false);
        return;
      }

      if (Date.now() - startedAt >= FRONTROW_WAIT_TIMEOUT) {
        setLoading(button, false);
        button.focus({ preventScroll: true });
        return;
      }

      window.setTimeout(attemptOpen, FRONTROW_WAIT_INTERVAL);
    }

    window.setTimeout(attemptOpen, FRONTROW_WAIT_INTERVAL);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-adv2-frontrow-modal-open]');
    if (!trigger) return;

    event.preventDefault();
    if (trigger.disabled || trigger.getAttribute('aria-busy') === 'true') return;
    if (!openOfficialFrontrow()) waitForOfficialFrontrow(trigger);
  });
})();
